import React, {Component} from 'react';
import {Col, Row, Container} from 'react-bootstrap';
import './Footer.css'

class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <Container>
                <Row className="footer-content">
                    <Col md="2" className="footer-label">
                        <p>Company</p>
                        <p>Services</p>
                        <p>Products</p>
                        <p>Careers</p>
                        <p>About Us</p>
                        <p>Contact Us</p>
                        
                    </Col>
                    <Col md="2" className="footer-label">
                        <p>Privacy Policy</p>
                        <p>Terms of support</p>
                    </Col>
                    <hr className="FooterLine">
                    </hr>
                </Row>
                <Row>
                    <Col md="12">
                        <i>&#xa9;</i> 2019 NVRE. All rights reserved
                    </Col>
                </Row>
                </Container>
            </footer>
        );
    }
}

export default Footer;